/**
 * The "no update for Nh" marker. Subtle on purpose (see
 * `task-staleness.ts`): a quiet task is a suspicion, not an alarm —
 * but it is the difference between an operator pressing Cancel ten
 * times into a void and an operator asking why nothing has published.
 */
import { quietHours } from './task-staleness';
import type { TaskState } from '../../api/rmf-client';

export function TaskQuietBadge({ task, now }: { task: TaskState; now?: number }) {
  const hours = quietHours(task, now);
  if (hours === null) return null;
  return (
    <span
      className="nx-task-quiet"
      data-testid="task-quiet-badge"
      data-hours={hours}
      title="Nothing has published for this task in that long. If its fleet adapter was restarted, the task may be orphaned and no control command will reach it."
    >
      no update for {hours}h
    </span>
  );
}
